
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../../components/core/FitTextToBounds";
import LocaliseText from "../../components/core/LocaliseText";
import BtnReplayEnd from "../btns/BtnReplayEnd";
import BtnHomeEnd from "../btns/BtnHomeEnd";
/* START-USER-IMPORTS */
import UIButton from "../../components/core/UIButton";
import GameUI from "../../scenes/GameUI";
import {LevelNameValues} from "../../game/levels/level";
import {RunSettingsHandler} from "../../game/RunSettingsHandler";
import {LevelUtil} from "../../game/levels/LevelUtil";
import {GameDataHandler} from "../../game/GameDataHandler";
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class LevelFailed extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.visible = false;
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // screen
    const screen = scene.add.container(0, -106);
    this.add(screen);

    // arm
    const arm = scene.add.sprite(0, -221, "endscreen", "popup-arm.png");
    screen.add(arm);

    // panelNine
    const panelNine = scene.add.sprite(-2, 59, "endscreen", "popup-fail-box.png");
    screen.add(panelNine);

    // Title
    const title = scene.add.container(-1, -116);
    screen.add(title);

    // panelNine_1
    const panelNine_1 = scene.add.sprite(0, 0, "endscreen", "popup-heading-small.png");
    title.add(panelNine_1);

    // label
    const label = scene.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "New text";
    label.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "50px", "shadow.offsetY":3,"shadow.fill":true});
    label.setPadding({"left":20,"top":20,"right":20,"bottom":20});
    title.add(label);

    // label_body
    const label_body = scene.add.text(0, 60, "", {});
    label_body.setOrigin(0.5, 0.5);
    label_body.text = "New text";
    label_body.setStyle({ "color": "#f6f45a", "fontFamily": "Acme-Regular", "fontSize": "70px", "shadow.offsetY":5,"shadow.fill":true});
    label_body.setPadding({"left":20,"top":20,"right":20,"bottom":20});
    screen.add(label_body);

    // btnReplayEnd
    const btnReplayEnd = new BtnReplayEnd(scene, 99, 232);
    screen.add(btnReplayEnd);

    // btnHomeEnd
    const btnHomeEnd = new BtnHomeEnd(scene, -102, 235);
    screen.add(btnHomeEnd);

    // taz
    const taz = scene.add.image(-423, 384, "endscreen", "taz-level-fail.png");
    taz.setOrigin(0.5, 1);
    this.add(taz);

    // teammate
    const teammate = scene.add.image(416, 383, "endscreen", "marvin-popup.png");
    teammate.setOrigin(0.5, 1);
    this.add(teammate);

    // label (components)
    const labelFitTextToBounds = new FitTextToBounds(label);
    labelFitTextToBounds.maxWidth = 450;
    labelFitTextToBounds.constrainByWidth = true;
    const labelLocaliseText = new LocaliseText(label);
    labelLocaliseText.copyId = "levelFailed";

    // label_body (components)
    const label_bodyLocaliseText = new LocaliseText(label_body);
    label_bodyLocaliseText.copyId = "levelFailedBody";

    this.cover = cover;
    this.screen = screen;
    this.btnReplayEnd = btnReplayEnd;
    this.btnHomeEnd = btnHomeEnd;
    this.taz = taz;
    this.teammate = teammate;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private screen: Phaser.GameObjects.Container;
  private btnReplayEnd: BtnReplayEnd;
  private btnHomeEnd: BtnHomeEnd;
  private taz: Phaser.GameObjects.Image;
  private teammate: Phaser.GameObjects.Image;
  public screenStartY: number = -700;

  /* START-USER-CODE */

  public awake() {
    this.cover.setInteractive();

    this.btnReplayEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.Replay);
    });

    this.btnHomeEnd.once(UIButton.events.clicked, () => {
      this.scene.events.emit(GameUI.events.LevelSelect);
    });

  }

  public activate() {
    this.transitionIn();
  }

  protected transitionIn() {
    let startDelay = 400;

    this.cover.alpha = 0;
    this.cover.visible = true;
    let screenFinishY = this.screen.y;
    this.screen.y = this.screenStartY;
    let tazFinishY = this.taz.y;
    this.taz.y += this.taz.height;
    let teammateFinishY = this.teammate.y;
    this.teammate.y += this.teammate.height*2;

    this.teammate.setTexture(this.teammate.texture.key,"popup-"+GameDataHandler.getLastCharacterPlayed(this.scene).toLowerCase()+".png");

    this.btnReplayEnd.UIButton.pulseDelay = startDelay + 3500;

    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.SndFailTrombone, Sounds.Channel.SFX, {
      volume: 1
    });


    let timeline = this.scene.add.timeline([
      {
        at: Math.max(0, startDelay - 100),
        run: () => {
          this.scene.add.tween({
            targets: this.cover,
            alpha: { from: 0, to: 1 },
            // duration: 300,
            delay: startDelay,
            ease: Phaser.Math.Easing.Cubic.InOut
          });
        }
      },
      {
        at: startDelay + 300,
        run: () => {
          this.scene.add.tween({
            targets: this.screen,
            y: { from: this.screenStartY, to: screenFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Back.Out,
            // delay: startDelay + 300,
            callbackScope: this
          });
        }
      },
      {
        at: startDelay + 600,
        run: () => {
          this.scene.add.tween({
            targets: this.taz,
            y: { from: this.taz.y + this.taz.height, to: tazFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Quadratic.InOut,
            // delay: startDelay + 300,
            callbackScope: this,
            onStart:()=>{this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazUnhappyYell, Sounds.Channel.SFX, { volume: 2.0});}
          });
        }
      },
      {
        at: startDelay + 800,
        run: () => {
          this.scene.add.tween({
            targets: this.teammate,
            y: { from: this.teammate.y + this.teammate.height, to: teammateFinishY },
            duration: 500,
            ease: Phaser.Math.Easing.Quadratic.InOut,
            // delay: startDelay + 300,
            callbackScope: this
          });
        }
      }

    ]);

    timeline.play(true);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
